import { templateHelpers } from './templateHelpers';
import { adams } from 'app/scripts/lib/adams';

export const teacupWithHelpers = templateHelpers(adams);
